import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader } from '../ui/dialog';
import { DialogDescription, DialogTitle } from '@radix-ui/react-dialog';

import { Button } from '../ui/button';

import { useDispatch } from 'react-redux';
import { doGetPremiumFeatures } from '../../modules/premiumFeatures/stores/thunk';
import { AppDispatch } from '../../redux/store';

import { PremiumFeatureForm } from './PremiumFeatureForm';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { ToggleLeft, ToggleRight } from 'lucide-react';

const pretty = (feature: string) =>
  feature
    .split('_')
    .map((w) => w[0].concat(w.slice(1).toLowerCase()))
    .join(' ');

export const PremiumFeaturesDialog = ({
  open,

  close,
  company,
}: {
  open: boolean;

  close: () => void;
  company: any;
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const [features, setFeatures] = useState([]);

  const fetchData = async () => {
    if (company?.id && open) {
      const response = await dispatch(doGetPremiumFeatures({ companyId: company.id }));
      if (response.payload) {
        const missingFeatures = ['PERFORMANCE_DASHBOARD', 'SUSTAINABILITY_REPORT', 'FULLY_TRACKED']
          .filter((f) => !response.payload.find((p) => p.feature === f))
          .map((mf) => ({
            feature: mf,
            status: 'SUSPENDED',
            companyId: company.id,
          }));
        setFeatures([...response.payload, ...missingFeatures].sort((a, b) => (a.feature < b.feature ? -1 : 1)));
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [company, open]);

  return (
    <Dialog open={open} onOpenChange={() => open && close()}>
      <DialogContent className="md:min-w-[800px]">
        <DialogHeader>
          <DialogTitle className="text-xl font-extrabold">Premium features for {company?.name}</DialogTitle>
          <DialogDescription asChild>
            <>
              <p className="">Manage premium features for users connected to the {company?.name} company</p>
              <Accordion className="mt-4" type="single" collapsible>
                {features.map((f) => (
                  <div key={f.feature} className="mt-4">
                    <AccordionItem value={f.feature}>
                      <AccordionTrigger>
                        <div className="flex items-center">
                          {f.status === 'ACTIVE' ? (
                            <ToggleRight className="mr-4" />
                          ) : (
                            <ToggleLeft className="mr-4" color="gray" />
                          )}
                          {pretty(f.feature)}
                        </div>
                      </AccordionTrigger>

                      <AccordionContent>
                        <div className="flex space-x-2 justify-between my-4 items-center">
                          <PremiumFeatureForm premiumFeature={f} update={fetchData} />
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </div>
                ))}
              </Accordion>
            </>
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button className="rounded" onClick={close}>
            Done
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
